import React from "react";
import { useTranslation } from "react-i18next";

import {
	Grid,
	Typography
} from "@mui/material";

import PriceDifferenceSVG from '../../../../images/price_difference.svg';
import StockSVG from '../../../../images/stock.svg';
import StockOutAlertSVG from '../../../../images/stockout.svg';
import Wall from '../../../redux/containers/features/digitalShelf/Wall';
import WallSelector from '../../../redux/containers/features/digitalShelf/WallSelector';

export default function DigitalShelf() {
	const { t } = useTranslation();

	const [imgsDict, setImgsDict] = React.useState(null);
	const [stock, setStock] = React.useState();
	const [priceDifference, setPriceDifference] = React.useState();
	const [stockOut, setStockOut] = React.useState();
	const [spread, setSpread] = React.useState();

	// load svgs to use later
	React.useEffect(() => {
		if (!(stock?.stock) && StockSVG) {
			const stock = new Image();
			stock.src = StockSVG//iconDataUrl;
			stock.onload = () => { setStock(stock) }
		}
	}, []);
	React.useEffect(() => {
		if (!(priceDifference?.priceDiff) && PriceDifferenceSVG) {
			const priceDiff = new Image();
			priceDiff.src = PriceDifferenceSVG;
			priceDiff.onload = () => { setPriceDifference(priceDiff) }
		}
	}, []);

	React.useEffect(() => {
		if (!(stockOut?.stockout) && StockOutAlertSVG) {
			const stockout = new Image();
			stockout.src = StockOutAlertSVG;
			stockout.onload = () => { setStockOut(stockout) }
			const spread = new Image();
			spread.src = StockOutAlertSVG;
			spread.onload = () => { setSpread(spread) }
		}
	}, []);

	// display loaded images with React.useEffect
	React.useEffect(() => {
		if (stock && priceDifference && stockOut) {
			setImgsDict({
				stock: stock, price_difference: priceDifference,
				stockout: stockOut,
				spread_to_fill: spread
			});
		}
	}, [stockOut, stock, priceDifference]);

	return (
		<Grid container direction={'column'} px={2}>
			<Grid item sx={{ mt: 2, mb: 1 }}>
				<Typography sx={{ fontSize: '34px', }}>
					{t('cws_app.general.Digital_Shelf', "Digital Shelf")}
				</Typography>
			</Grid>
			<Grid item container direction={'row'} justifyContent={'flex-start'} alignItems={'center'}>
				<WallSelector />
				<Wall imgsDict={imgsDict} />
			</Grid>
		</Grid>
	);
}